export default {"src":"/login-app/[GIT_HASH]/_next/static/media/table_columns.ee1e8af0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};